module.exports={
    logout  : "退出登录",
    my      :'我的',
    scqx    :'删除权限',
    qxgl    :'权限管理',
    qdzxzhm :'确定退出登录吗？',
    qtxkh   :'请填写卡号',
    qd      :'确定',
    qx      :'取消',
    gb      :'关闭',
    kh      :'卡号',
    kmewm   :'开门二维码',
    dl      :'登录',
    name    :'用户名',
    qtxname :'请填写用户名',
    pwas    :'密码',
    qtxpwas :'请填写密码',
    tj      :'提交',
    zczh    :'注册账号',
    zc      :'注册',
    sjhm    :'手机号码',
    qtxsjhm :'请填写手机号码',
    yzm     :'短信验证码',
    qtxyzm  :'请填写验证码',
    yyzhqqdl:'已有账号，前去登录',
	khcwqcxsr:'输入卡号有误，请重新输入',
    hqyzm   :'获取短信验证码',
    zccg    :'注册成功',
    zcsb    :'注册失败',
    fscg    :'发送成功',
    fssb    :'发送失败',
    yhycz   :'用户已存在',
	xzsq	:'请选择社区',


    xgmm    : "修改密码",
    zhmm    :'重置密码',
    qrmm    :'确认密码',
    zhyxmm  :"找回密码邮箱",
    yxyzm   :'邮箱验证码',
    hqyxyzm :'获取邮箱验证码',
    zzmmyx  :'重置密码邮箱',
    lcmmbyc :'俩次密码不一致',
    xgcg    :'修改成功',
    xgsb    :'修改失败',
    qtxyxyx  :'请填写有效邮箱',
    lsmhhq  :'60秒后重新获取',
    hqyyyzmcg:'获取邮箱验证码成功',
    zhmmbd  :'账号密码不正确',
	qsr8wdkh:'请输入8位的卡号',
	jym:'校验码',
	syym:'所有原码',
	rmcs:'热门城市',
	xzgjhdq:'选择国家或地区',

    // 国家
    // 手机号国家区
    zgdl:'中国大陆',
    zgxg:'中国香港',
    zgam:'中国澳门',
    zgtw:'中国台湾',
    afh:"阿富汗",
    ade:'安道尔',
    agt:'阿根廷',
    ymny:'亚美尼亚',
    alb:'阿鲁巴',
    adl:"奥地利",
    asbj:'阿塞拜疆',
    am:'阿曼',
    alj:'阿联酋',

    bhm:'巴哈马',
    bl:'巴林',
    bbds:'巴巴多斯',
	bdlg:'波多黎各',
    bjst:'巴基斯坦',
    bels:'白俄罗斯',
    bls:'比利时',
    cxx:'朝鲜',
    cdjny:'赤道几内亚',
    dg:'德国',
    dm:'丹麦',
    jbt:'吉布提',
    dmnjghg:'多米尼加共和国',
    els:'俄罗斯',
    egde:'厄瓜多尔',
    aj:'埃及',
    aseby:'埃塞俄比亚',

    fg:'法国',
    fl:'芬兰',
    flb:'菲律宾',
    fdg:'梵蒂冈',

    gby:'冈比亚',
    ggghg:'刚果共和国',
    glby:'哥伦比亚',
	gljy:'格鲁吉亚',
    gba:'古巴',
    hg:'韩国',
    hl:'荷兰',
    hd:'海地',

    jbz:'柬埔寨',
    jlbs:'基里巴斯',
    jny:'几内亚',
    jbbw:"津巴布韦",
	jk:"捷克",
    kml:'喀麦隆',
    kmqt:'开曼群岛',
    kny:'肯尼亚',
    kwt:'科威特',
    kldy:'克罗地亚',
    kte:'卡塔尔',
    lys:'老挝',
    lby:'利比亚',
	lbn:'黎巴嫩',
    lwd:'卢旺达',
    mg:'美国',
    mlxy:'马来西亚',
    mxg:'墨西哥',
    ml:"马里",
    nf:'南非',
    nbe:'尼泊尔',
    nrly:'尼日利亚',
    nw:'挪威',
    plqd:'帕劳群岛',
    pty:'葡萄牙',
    rb:'日本',
    rd:'瑞典',
    rs:'瑞士',
    stalb:'沙特阿拉伯',
    sd:'苏丹',
    slxy:'圣卢西亚',
    tg:'泰国',
    tjs:'汤加',
    teq:'土耳其',
    wnrl:'委内瑞拉',
    wl:'文莱',
    wkl:'乌克兰',
    xxl:'新西兰',
    xjb:'新加坡',
    xby:'西班牙',
    xl:'希腊',
    xyl:'匈牙利',
    xly:'叙利亚',
    ydl:'意大利',
    yg:'英国',
    ydnxy:'印度尼西亚',
    yd:'印度',
	ydd:'约旦',
    yn:'越南',
    ylk:'伊拉克',
    zl:'智利',
    zfghg:'中非共和国',

    //改版
    qsrdxyzm:'请输入短信验证码',
    fsyzm:'发送验证码',
    yIDhmmdl:'以ID和密码登录',
    qsrID:'请输入ID',
    qsrmm:'请输入密码',
    login:'登录',
    qsrsjhm:'请输入手机号码',
    ysjhmdl:'以手机号码登录',
    hqyzmsb:'获取验证码失败！',
    mhzxhq:'秒后重新获取',
    xyhzc:'新用户注册',
    yhm:'用户名',
    mm:'密码',
    qymc:'企业名称',
    yx:'邮箱',
    qsryxyzm:'请输入邮箱验证码',
    hqyzmcg:'获取验证码成功！',
    yzmbzq:'验证码不正确',
    zhhmmcw:'账号或密码错误',
    xmm:'新密码',
    szsb:'设置失败',
    szcg:'设置成功',
    zhhyzmcw:'账号或验证码错误',
    jmm:'旧密码',

    sjhmycz:'手机号码已存在',
    yxyzmbzq:'邮箱验证码不正确',
    yxhsjhmbcz:'邮箱或手机号码不存在',
	qxzyxsj:'请选择有效时间',

    szkh:'数字卡号',
    fkyq:'访客邀请',
    wdmk:'我的门卡',
    bdcg:'绑定成功',
    bdsb:'绑定失败',

    qdjfx:'请点击分享下面的链接生成的开门二维码',
    yxqks:'有效期从现在开始到',
    nn:'内',
    lj:'链接',
    fx:'分享',

    cdcc:'生成code出错',
    fzcg:'复制成功',
    fzsb:'复制失败',
    sss:'时',
    fff:'分',
	xzsj:'选择时间',
    
    kmewmygq:'开门二维码已经过期',

    fzcgts:'您使用的浏览器不支持直接分享   请把已自动复制的内容发给被邀请人 '

}